import React, { createContext, useState } from 'react';

export const CameraSection = createContext();

const CameraContextProvider = (props) => {
    const [cameraPage, setCameraPage] = useState({ firstPage: true, addCamera: false, editCamera: false, deleteCamera: false });

    const CameraShowHideFunc = (page) => {
        switch (page) {
            case "firstPage":
                setCameraPage({ firstPage: true, addCamera: false, editCamera: false, deleteCamera: false })
                break;
            case "addCamera":
                setCameraPage({ firstPage: false, addCamera: true, editCamera: false, deleteCamera: false })
                break;
            case "editCamera":
                setCameraPage({ firstPage: false, addCamera: false, editCamera: true, deleteCamera: false })
                break;
            case "deleteCamera":
                setCameraPage({ firstPage: false, addCamera: false, editCamera: false, deleteCamera: true })
                break;
        }
    }

    return (
        <>
            <CameraSection.Provider value={{ cameraPage, CameraShowHideFunc }}>
                {props.children}
            </CameraSection.Provider>
        </>
    );
};

export { CameraContextProvider };